"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationResponseDtoChannelEnum = void 0;
exports.instanceOfNotificationResponseDto = instanceOfNotificationResponseDto;
exports.NotificationResponseDtoFromJSON = NotificationResponseDtoFromJSON;
exports.NotificationResponseDtoFromJSONTyped = NotificationResponseDtoFromJSONTyped;
exports.NotificationResponseDtoToJSON = NotificationResponseDtoToJSON;
exports.NotificationResponseDtoToJSONTyped = NotificationResponseDtoToJSONTyped;
/**
 * @export
 */
exports.NotificationResponseDtoChannelEnum = {
    Push: 'push',
    Email: 'email',
    Sms: 'sms',
    InApp: 'in-app'
};
/**
 * Check if a given object implements the NotificationResponseDto interface.
 */
function instanceOfNotificationResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('body' in value) || value['body'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('data' in value) || value['data'] === undefined)
        return false;
    if (!('channel' in value) || value['channel'] === undefined)
        return false;
    if (!('isRead' in value) || value['isRead'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function NotificationResponseDtoFromJSON(json) {
    return NotificationResponseDtoFromJSONTyped(json, false);
}
function NotificationResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'userId': json['userId'],
        'title': json['title'],
        'body': json['body'],
        'type': json['type'],
        'data': json['data'],
        'channel': json['channel'],
        'isRead': json['isRead'],
        'sentAt': json['sentAt'] == null ? undefined : json['sentAt'],
        'readAt': json['readAt'] == null ? undefined : json['readAt'],
        'createdAt': (new Date(json['createdAt'])),
    };
}
function NotificationResponseDtoToJSON(json) {
    return NotificationResponseDtoToJSONTyped(json, false);
}
function NotificationResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'userId': value['userId'],
        'title': value['title'],
        'body': value['body'],
        'type': value['type'],
        'data': value['data'],
        'channel': value['channel'],
        'isRead': value['isRead'],
        'sentAt': value['sentAt'],
        'readAt': value['readAt'],
        'createdAt': value['createdAt'].toISOString(),
    };
}
